import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { useTheme } from '@mui/system';
import Button from '@mui/material/Button';
import { LoadingButton } from '@mui/lab';
import { isEmbedded } from 'src/util';

export default function DrawerWrapper(
  props: Readonly<{
    children: React.ReactNode;
    customWidth?: number;
    disableSave?: boolean;
    exception: boolean;
    handleClose: () => void;
    headerText: string;
    loading?: boolean;
    onSaveClick: () => void;
    setWarnDeactivate?: React.Dispatch<React.SetStateAction<boolean>>;
    subHeaderText?: string;
  }>
) {
  const theme = useTheme();
  return (
    <Drawer
      anchor={'right'}
      data-testid="gds-vp-edit-order-line-drawer"
      onClose={props.handleClose}
      open={true}
      sx={{
        '.MuiDrawer-paperAnchorRight': {
          height: isEmbedded() ? '100vh' : `calc(100vh - 50px)`,
          top: isEmbedded() ? 0 : 50,
          width: props.customWidth ?? 400,
        },
      }}
    >
      <Box
        data-testid="gds-vp-edit-order-line-header"
        paddingTop={`20px`}
        paddingX={`20px`}
      >
        <Stack direction="row" justifyContent="space-between">
          {props.subHeaderText && (
            <Stack flex={1}>
              <Typography
                fontSize={16}
                lineHeight={`22px`}
                variant="smalltextsemibold"
              >
                {props.headerText}
              </Typography>
              <Typography lineHeight={`22px`} variant="body2">
                {props.subHeaderText}
              </Typography>
            </Stack>
          )}
          {!props.subHeaderText && (
            <Typography
              fontSize={16}
              lineHeight={`22px`}
              sx={{ alignContent: 'center', display: 'grid' }}
              variant="smalltextsemibold"
            >
              {props.headerText}
            </Typography>
          )}
          <IconButton
            data-testid="gds-vp-ass-closeicon"
            onClick={props.handleClose}
            size="small"
            sx={{ alignSelf: 'baseline' }}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
        <Divider
          sx={{
            borderColor: theme.palette.neutral[200],
            marginBottom: `8px`,
            marginTop: `20px`,
          }}
        />
      </Box>
      {props.children}
      <Stack
        direction="row"
        justifyContent={'flex-end'}
        marginTop="auto"
        paddingX={`16px`}
        paddingY={`24px`}
        spacing={`12px`}
      >
        {!props.exception && (
          <Button
            data-testid="gds-vp-edit-order-line-deactivate-btn"
            onClick={() =>
              props.setWarnDeactivate
                ? props.setWarnDeactivate(true)
                : undefined
            }
            sx={{ color: theme.palette.error[700] }}
            variant="newOutlined"
          >
            Deactivate
          </Button>
        )}
        <Button
          data-testid="gds-vp-edit-order-line-cancel-btn"
          onClick={props.handleClose}
          variant="newOutlined"
        >
          Cancel
        </Button>
        <LoadingButton
          data-testid="gds-vp-edit-order-line-save-btn"
          disabled={props.disableSave}
          loading={props.loading}
          onClick={props.onSaveClick}
          variant="newContained"
        >
          Save
        </LoadingButton>
      </Stack>
    </Drawer>
  );
}
